import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  avatar: {
    background: theme.palette.primary.main,
    height: '2.3em',
    width: '2.3em'
  },
  description: {
    fontWeight: theme.typography.fontWeightBold
  },
  total: {
    fontWeight: theme.typography.fontWeightBold
  },
  profileCell: {
    width: '2.3em'
  },
  rowBgColor: {
    '&:nth-child(odd)': {
      backgroundColor: theme.palette.background.dark
    }
  },
  details: {
    borderLeft: `.2em solid ${theme.palette.primary.main}`
  },
  descriptionCell: {
    width: 300,
    minWidth: 300
  },
  numericCell: {
    width: 120,
    minWidth: 120
  },
  unitCell: {
    width: 100,
    minWidth: 100
  },
  qtyCell: {
    width: 80,
    minWidth: 80
  },
  snCell: {
    width: 150,
    minWidth: 150
  }
}));

export default useStyles;
